<div [formGroup]="formGroup">
    <label
        [for]="controlName"
        class="form-control-label"
        [ngStyle]="{ display: displayLabel ? 'inline-block' : 'none' }">
        {{ label }}
        <span class="text-danger">{{ isRequired ? '*' : '' }}</span>
        <sume-help-tooltip
            *ngIf="helpMessage"
            [message]="helpMessage"
            size="small">
        </sume-help-tooltip>
    </label>
    <div class="input-group" *ngIf="currency">
        <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">R$</span>
        </div>
        <input
            class="form-control"
            autocomplete="off"
            currencyMask
            [id]="controlName"
            [formControlName]="controlName"
            [placeholder]="placeholder"
            (click)="$any($event.target).select()"
            [options]="{ prefix: '', thousands: '.', decimal: ',' }"
            [ngClass]="{ 'is-invalid': isInvalid }" />
        <div class="invalid-feedback">
            <ng-container *ngTemplateOutlet="feedbackBlock"></ng-container>
        </div>
    </div>
    <input
        *ngIf="!currency"
        [id]="controlName"
        [formControlName]="controlName"
        [type]="type"
        [dropSpecialCharacters]="dropSpecialCharacters"
        [min]="type === 'number' && range[0]"
        [max]="type === 'number' && range[1]"
        [step]="type === 'number' && step"
        class="form-control"
        [mask]="mask"
        [placeholder]="placeholder"
        [ngClass]="{ 'is-invalid': isInvalid }" />
    <div class="invalid-feedback">
        <ng-container *ngTemplateOutlet="feedbackBlock"></ng-container>
    </div>

    <!-- Feedback -->
    <ng-template #defaultFeedback>
        {{
            formControl.errors?.required && type === 'number'
                ? 'Digite um número.'
                : 'Campo obrigatório.'
        }}
        {{
            formControl.errors?.pattern && 'O valor deve ser um número válido.'
        }}
        {{
            formControl.errors?.min &&
                'O número deve ser no mínimo ' +
                    formControl.errors['min']['min'] +
                    '.'
        }}
        {{
            formControl.errors?.max &&
                'O número deve ser no máximo ' +
                    formControl.errors['max']['max'] +
                    '.'
        }}
        {{
            (!formControl.errors && (messages?.invalid || 'Campo inválido.')) ||
                ''
        }}
    </ng-template>
    <ng-template #feedbackBlock>
        <ng-container *ngIf="customFeedbackMessage; else defaultFeedback">
            {{ customFeedbackMessage }}
        </ng-container>
    </ng-template>
</div>
